// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal.hidden {
	display: none;
}

.custom-modal-background.hidden {
	display: none;
}

.custom-modal {
	display: block;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 2000;
	width: 100%;
	max-height: 100%;
	box-sizing: border-box;
	padding: 2rem;
}

.custom-modal-background {
	position: absolute;
	width: 100vw;
	height: 100vh;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 1999;
	padding: 2rem;
}

.custom-modal-body {
	position: relative;
	padding: 1rem;
	box-sizing: border-box;
}

.custom-modal-content {
	background-color: #E8E3F9;
	border-radius: 0.5rem;
	max-width: 100%;
	max-height: 100%;
}

.custom-modal-header {
	display: flex;
	justify-content: space-between;
    /* flex-shrink: 0; */
    align-items: center;
    padding: 1rem;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: calc(0.5rem - 1px);
    border-top-right-radius: calc(0.5rem - 1px);
}

.custom-modal-title {
	margin-bottom: 0;
	line-height: 1.5;
}

.custom-modal-close-btn {
	font-weight: bold;
	font-size: 21px;
	line-height: 1;
	color: #000000;
	text-shadow: 0 1px 0 #fff;
	opacity: .2;
	margin-top: -20px;
	border: 0;
	padding: 0;
	cursor: pointer;
}

.custom-modal-list {
	list-style-type: none;
	padding: 0;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 0.5rem;
}





.custom-modal-item {
	/* margin: 10px auto 0 auto; */
	width: 80%;
	cursor: pointer;
	/* padding: 0.5rem 0; */
	border-radius: 0.5rem;
}

.custom-modal-text-color-item {
	font-size: 2rem;
	padding: 25px 0;
}

.custom-modal-text-size-item {
	background: white;
	border: 0;
	/* padding: 0.5rem 0; */
	border-radius: 1.1rem;
}

.custom-modal-font-item {
	font-size: 2rem;
	background: white;
}

.active {
	border: red 2px dashed !important;
}

.custom-modal-grid {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(106px, 1fr));
	gap: 10px;
}

.custom-modal-flex {
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	gap: 10px;
}

@media (min-width: 576px) {
	.modal-sm {
		--bs-modal-width: 500px !important;
	}
}
@media (max-width: 576px) {
	.custom-modal {
		padding: 0.5rem !important
	}
}
.signature-modal .modal-content {
	max-width: 600px;
	margin: 0 auto;
}

.zoom-modal .modal-content {
	border-radius: 30px !important;
	background: transparent !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/style/modal.css"],"names":[],"mappings":"AAAA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,gCAAgC;CAChC,aAAa;CACb,WAAW;CACX,gBAAgB;CAChB,sBAAsB;CACtB,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,MAAM;CACN,OAAO;CACP,8BAA8B;CAC9B,aAAa;CACb,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,8BAA8B;IAC3B,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,cAAc;CACd,yBAAyB;CACzB,WAAW;CACX,iBAAiB;CACjB,SAAS;CACT,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,kBAAkB;CAClB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,sBAAsB;CACtB,WAAW;AACZ;;;;;;AAMA;CACC,8BAA8B;CAC9B,UAAU;CACV,eAAe;CACf,uBAAuB;CACvB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,SAAS;CACT,uBAAuB;CACvB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,aAAa;CACb,2DAA2D;CAC3D,SAAS;AACV;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,eAAe;CACf,SAAS;AACV;;AAEA;CACC;EACC,kCAAkC;CACnC;AACD;AACA;CACC;EACC;CACD;AACD;AACA;CACC,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,8BAA8B;CAC9B,kCAAkC;AACnC","sourcesContent":[".custom-modal.hidden {\n\tdisplay: none;\n}\n\n.custom-modal-background.hidden {\n\tdisplay: none;\n}\n\n.custom-modal {\n\tdisplay: block;\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tz-index: 2000;\n\twidth: 100%;\n\tmax-height: 100%;\n\tbox-sizing: border-box;\n\tpadding: 2rem;\n}\n\n.custom-modal-background {\n\tposition: absolute;\n\twidth: 100vw;\n\theight: 100vh;\n\ttop: 0;\n\tleft: 0;\n\tbackground: rgba(0, 0, 0, 0.5);\n\tz-index: 1999;\n\tpadding: 2rem;\n}\n\n.custom-modal-body {\n\tposition: relative;\n\tpadding: 1rem;\n\tbox-sizing: border-box;\n}\n\n.custom-modal-content {\n\tbackground-color: #E8E3F9;\n\tborder-radius: 0.5rem;\n\tmax-width: 100%;\n\tmax-height: 100%;\n}\n\n.custom-modal-header {\n\tdisplay: flex;\n\tjustify-content: space-between;\n    /* flex-shrink: 0; */\n    align-items: center;\n    padding: 1rem;\n    border-bottom: 1px solid #dee2e6;\n    border-top-left-radius: calc(0.5rem - 1px);\n    border-top-right-radius: calc(0.5rem - 1px);\n}\n\n.custom-modal-title {\n\tmargin-bottom: 0;\n\tline-height: 1.5;\n}\n\n.custom-modal-close-btn {\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tline-height: 1;\n\tcolor: #000000;\n\ttext-shadow: 0 1px 0 #fff;\n\topacity: .2;\n\tmargin-top: -20px;\n\tborder: 0;\n\tpadding: 0;\n\tcursor: pointer;\n}\n\n.custom-modal-list {\n\tlist-style-type: none;\n\tpadding: 0;\n\ttext-align: center;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tflex-direction: column;\n\tgap: 0.5rem;\n}\n\n\n\n\n\n.custom-modal-item {\n\t/* margin: 10px auto 0 auto; */\n\twidth: 80%;\n\tcursor: pointer;\n\t/* padding: 0.5rem 0; */\n\tborder-radius: 0.5rem;\n}\n\n.custom-modal-text-color-item {\n\tfont-size: 2rem;\n\tpadding: 25px 0;\n}\n\n.custom-modal-text-size-item {\n\tbackground: white;\n\tborder: 0;\n\t/* padding: 0.5rem 0; */\n\tborder-radius: 1.1rem;\n}\n\n.custom-modal-font-item {\n\tfont-size: 2rem;\n\tbackground: white;\n}\n\n.active {\n\tborder: red 2px dashed !important;\n}\n\n.custom-modal-grid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(auto-fit, minmax(106px, 1fr));\n\tgap: 10px;\n}\n\n.custom-modal-flex {\n\tdisplay: flex;\n\tjustify-content: center;\n\tflex-wrap: wrap;\n\tgap: 10px;\n}\n\n@media (min-width: 576px) {\n\t.modal-sm {\n\t\t--bs-modal-width: 500px !important;\n\t}\n}\n@media (max-width: 576px) {\n\t.custom-modal {\n\t\tpadding: 0.5rem !important\n\t}\n}\n.signature-modal .modal-content {\n\tmax-width: 600px;\n\tmargin: 0 auto;\n}\n\n.zoom-modal .modal-content {\n\tborder-radius: 30px !important;\n\tbackground: transparent !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
